import React from 'react'
import { Controller } from 'react-hook-form'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { validateRequiredStringValue } from './_utils'
import { useUserFormContext } from '../utils/userFormContext'

const LastName: React.FC = () => {
    const { state } = useUserFormContext()
    const { control } = useFormContextUser()

    return (
        <Controller
            control={control}
            name="lastName"
            rules={{
                required: 'Cette information est obligatoire et n’a pas été renseignée',
                validate: validateRequiredStringValue,
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Nom d’exercice"
                    required
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    placeholder="Nom d’exercice"
                    {...field}
                    value={field?.value ?? ''}
                    locked={state.rppsLocked}
                    disabled={state.rppsLocked}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default LastName
